import React from 'react';
import { useSelector } from 'react-redux';
import { Button, styled } from '@mui/material';
import {
  CustomisedButton,
  CustomisedIconButton,
  CustomisedSaveButton,
  CustomisedUploadButton,
  CustomisedDeleteButton,
  CustomisedSettingsDeleteButton,
  CustomisedSettingsLightModeDeleteButton,
  CustomisedLightModeDeleteButton,
  CustomisedLoadingButton,
} from './style';
import { Colors, DarkmodeColors } from 'app/constants/color';

const StyledButton = props => {
  const { darkmode } = useSelector(state => state.dark);

  const CustomisedIdentityButton = styled(Button)({
    height: '60px',
    width: '100%',
    backgroundColor: 'transparent',
    textTransform: 'none',
  });

  const CustomisedIdentitySmallButton = styled(Button)({
    height: '30px',
    width: 'max-content',
    backgroundColor: 'transparent',
    textTransform: 'none',
  });

  return (
    <>
      {props.name === 'BankID' ? (
        <CustomisedButton {...props} />
      ) : props.name === 'Arrowback' ? (
        <CustomisedIconButton {...props} />
      ) : props.name === 'Save' ? (
        <CustomisedSaveButton
          {...props}
          disabled={props.disabled}
          sx={{
            background: darkmode && Colors.primary,
            color: darkmode && 'white',
            ...props.sx,
            ':hover': {
              background: darkmode && DarkmodeColors.menuIcon,
              cursor: 'pointer',
            },
          }}
        />
      ) : props.name === 'Upload' ? (
        <CustomisedUploadButton {...props} />
      ) : props.name === 'Delete' ? (
        <CustomisedDeleteButton {...props} />
      ) : props.name === 'Settings-Delete' ? (
        <CustomisedSettingsDeleteButton {...props} />
      ) : props.name === 'Settings-Darkmode-Delete' ? (
        <CustomisedSettingsLightModeDeleteButton {...props} />
      ) : props.name === 'Edit-User-Delete' ? (
        <CustomisedLightModeDeleteButton {...props} />
      ) : props.name === 'Identity2' ? (
        <CustomisedIdentityButton {...props} sx={{ ...props.sx }} />
      ) : props.name === 'IdentitySmall' ? (
        <CustomisedIdentitySmallButton {...props} sx={{ ...props.sx }} />
      ) : props.name === 'LoadingButton' ? (
        <CustomisedLoadingButton
          {...props}
          disabled={props.disabled}
          sx={{
            background: darkmode && Colors.primary,
            color: darkmode && 'white',
            ...props.sx,
            ':hover': {
              background: darkmode && DarkmodeColors.menuIcon,
              cursor: 'pointer',
            },
          }}
        />
      ) : (
        <Button {...props}></Button>
      )}
    </>
  );
};

export default StyledButton;
